import { render, staticRenderFns } from "./editionC1.vue?vue&type=template&id=8b9de540&scoped=true&"
import script from "./editionC1.vue?vue&type=script&lang=js&"
export * from "./editionC1.vue?vue&type=script&lang=js&"
import style0 from "./editionC1.vue?vue&type=style&index=0&id=8b9de540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9de540",
  null
  
)

export default component.exports